import { render, staticRenderFns } from "./InfoAccordion.vue?vue&type=template&id=04b07b7e&scoped=true&"
import script from "./InfoAccordion.vue?vue&type=script&lang=js&"
export * from "./InfoAccordion.vue?vue&type=script&lang=js&"
import style0 from "./InfoAccordion.vue?vue&type=style&index=0&id=04b07b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b07b7e",
  null
  
)

export default component.exports